'use client';

import React from 'react';
import { Switch, type SwitchProps } from './Switch';

export interface SwitchVideoAudioProps extends Omit<SwitchProps, 'options' | 'value' | 'onChange'> {
  /**
   * Current mode: 'video' or 'audio'
   */
  mode?: 'video' | 'audio';

  /**
   * Callback when mode changes
   */
  onModeChange?: (mode: 'video' | 'audio') => void;

  /**
   * Text for video option
   */
  videoLabel?: string;

  /**
   * Text for audio option
   */
  audioLabel?: string;
}

export const SwitchVideoAudio: React.FC<SwitchVideoAudioProps> = ({
  mode = 'video',
  onModeChange,
  videoLabel = 'Video on',
  audioLabel = 'Audio only',
  ...props
}) => {
  const options = [
    { value: 'video', label: videoLabel },
    { value: 'audio', label: audioLabel },
  ];

  const handleChange = (value: string) => {
    if (onModeChange && (value === 'video' || value === 'audio')) {
      onModeChange(value);
    }
  };

  return (
    <Switch
      options={options}
      value={mode}
      onChange={handleChange}
      aria-label="Video or Audio mode selector"
      {...props}
    />
  );
};

SwitchVideoAudio.displayName = 'SwitchVideoAudio';

export default SwitchVideoAudio;